import React from "react";
import { Avatar, Badge, Tag } from "antd";
import "./index.less";
// import { useParams } from "react-router-dom";
import { useTranslate } from "@obsbot/remo-i18n";
export type RelationshipType = "lovers" | "bosom_friend" | "buddy";
export interface AvatarComProps {
    size?: number; // 可选的大小参数，默认为 40p
    avatar?: string; // 必选的图片 URL 参数
    userName?: string;
    userID: string;
    status?: string; // 可选的状态参数，默认为 default
    relationship?: RelationshipType;
    newMessage?: number;
    showStatus?: boolean;
    messageRemindType?: string;
    modeType?: "private" | "list-all" | "list-online" | "list-relation" | "apply-in" | "apply-out";
}
export const AvatarCom: React.FC<AvatarComProps> = props => {
    const {
        size = 40,
        avatar = undefined,
        userName,
        userID,
        status,
        relationship = "none",
        // newMessage = 0,
        // modeType,
        showStatus,
        messageRemindType,
    } = props;
    // const { id = "" } = useParams();
    const t = useTranslate();
    // 根据 DPI 比例计算一个轻微放大的系数，并通过 size 传递给 Avatar，避免 transform 造成裁切
    // 根据 DPI 计算一个用于 img 的轻微缩放因子（缩小一点，减少 cover 的裁切）
    const ratio = window.devicePixelRatio ?? 1;
    const imgScale = Math.max(0.94, 1 - (ratio - 1) * 0.03);
    // const [showCount, setShowCount] = useState<boolean>(false);
    const relation = (): React.ReactElement | null => {
        switch (relationship) {
            case "lovers": {
                // 问题原因是 loversSVG 是一个导入的 SVG 文件，不能直接当作 JSX 标签使用，需要将其作为组件使用
                return <Tag className="relation-tag lovers">{t("relationship.lovers")}</Tag>;
            }
            case "buddy": {
                return <Tag className="relation-tag buddy">{t("relationship.buddy")}</Tag>;
            }
            case "bosom_friend": {
                return (
                    <Tag className="relation-tag bosom_friend">
                        {t("relationship.bosom_friend")}
                    </Tag>
                );
            }
            default: {
                return null;
            }
        }
    };

    // 不再在头像处显示未读
    // useEffect(() => {
    //     if (modeType === "private" && id === userID) {
    //         setShowCount(false);
    //     } else {
    //         setShowCount(true);
    //     }
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [id, userID, modeType]);

    const getColor = (): string => {
        switch (status) {
            case "online": {
                return "var(--dot-online)";
            }
            case "invisible": {
                return "var(--dot-invisible)";
            }
            case "offline": {
                return "var(--dot-offline)";
            }
            default: {
                return "transparent";
            }
        }
    };
    return (
        <div key={userID} className="avatar-com">
            <Badge
                count={0}
                dot={messageRemindType === "AcceptNotNotify"}
                offset={[-2, 2]}
                size="small"
            >
                <Badge
                    className={"status-" + (status || "none")}
                    color={getColor()}
                    dot={true}
                    offset={[-5, size - 5]}
                >
                    <div
                        className="avatar-wrap"
                        style={{
                            width: size,
                            height: size,
                            borderRadius: "50%",
                            overflow: "hidden",
                            /* 修改：避免 inline-block 的基线对齐影响 */
                            display: "block",
                            ["--avatar-img-scale" as any]: imgScale,
                        }}
                    >
                        <Avatar
                            alt="Avatar"
                            className="avatar"
                            draggable={false}
                            shape="circle"
                            size={size}
                            src={avatar}
                        />
                    </div>
                </Badge>
            </Badge>
            <div className="user-info">
                <div className="user-info-content">
                    <span className="user-name">
                        {userID === "administrator" ? t("system-notice") : userName}
                    </span>
                    {relation()}
                </div>
                {showStatus && userID !== "administrator" && (
                    <div className={"user-status " + status}>
                        {t("account.status." + (status || "offline"))}
                    </div>
                )}
            </div>
        </div>
    );
};
